<!-- class="hogehoge" → styleで.hogehogeでスタイル指定できる -->
<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        新しいパスワードをご入力ください
      </div>
      <!-- ローディング -->
      <div v-if="putLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- 更新エラー表示 -->
      <div v-if="putErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            データの更新中に問題が発生しました。
          </div>
        </div>
      </div>
      <!-- 変更済み表示 -->
      <div v-if="passwordChangeFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div class="errSpan" style="font-size:x-large;">
          ログインパスワードの変更が完了致しました
        </div>
      </div>
      <form>
        <validation-observer ref="obs" v-slot="ObserverProps">
          <p class="inputTitle">現在のパスワード</p>
          <validation-provider name="現在のパスワード" rules="required|min:8|max:64|password" mode="lazy">
            <div slot-scope="ProviderProps">
              <input type="password" class="text small" v-model="oldPassword">
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
          </validation-provider>
          <p class="inputTitle">新しいパスワード</p>
          <div class="inputTitle">*最小桁数8桁</div>
          <validation-provider name="新しいパスワード" rules="required|min:8|max:64|password" vid="confirmation" mode="lazy">
            <div slot-scope="ProviderProps">
              <input type="password" class="text small" v-model="newPassword">
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
          </validation-provider>
          <p class="inputTitle">新しいパスワードの再入力</p>
          <validation-provider name="新しいパスワードの再入力" rules="required|confirmed:confirmation|min:8|max:64|password" mode="lazy">
            <div slot-scope="ProviderProps">
              <input type="password" class="text small" v-model="newPasswordConfirm">
              <div class="errMsg" v-if="ProviderProps.errors[0]">
                <span class="errSpan">
                  {{ ProviderProps.errors[0] }}
                </span>
              </div>
            </div>
          </validation-provider>
          <div class="buttonGroup">
            <button class="btn" type="button" @click="confirm"
              v-bind:class="{ disabled: ObserverProps.invalid || !ObserverProps.validate,
                 active: !ObserverProps.invalid && ObserverProps.validate && !passwordChangeFlg}"
              :disabled="ObserverProps.invalid || !ObserverProps.validated">変更
            </button>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>

</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, max, min, confirmed, regex } from 'vee-validate/dist/rules';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';

export default {
  title: 'パスワード変更',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
  },
  data() {
    return {
      id: '',
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: '',
      // ローディング
      putLodingFlg: false,  // データ更新時ローディングフラグ
      putErrorFlg: false,   // データ更新時エラーフラグ
      passwordChangeFlg: false, // パスワード変更完了フラグ
    };
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 変更ボタン押下時処理
    async confirm() {
      try {
        this.putErrorFlg = false;
        this.putLodingFlg = true;
        // パスワード変更処理呼び出し
        this.$cognito.updatePassword(this.oldPassword, this.newPassword);
        this.passwordChangeFlg = true;
      } catch (error) {
        this.putErrorFlg = true;
      } finally {
        this.putLodingFlg = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/variables.scss";

</style>
